<template>
  <ImportPersonOrg />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
